import React, { ReactNode, useMemo } from 'react';

import { ItemWithTranslation } from 'types/swagger';
import classNames from 'classnames';
import { isNotEmpty } from 'utility/functions';
import styles from './ScommesseTableSubtitle.module.scss';
import { useTranslation } from 'hooks/useLingUI';

export type ScommesseTableSubtitleProps = ItemWithTranslation<{ header?: string }> & {
  className?: string;
  children?: JSX.Element | ReactNode | string;
};

export const ScommesseTableSubtitle = ({ header, headerTrKey, className, children }: ScommesseTableSubtitleProps) => {
  const { t } = useTranslation();

  const childElement = useMemo(() => {
    if (!!children) return children;

    if (isNotEmpty(header)) {
      return t(headerTrKey, header);
    }

    return <React.Fragment key={`null-placeholder`}>&nbsp;</React.Fragment>;
  }, [children, header, headerTrKey, t]);

  return (
    <span className={classNames(styles.text, className)} suppressHydrationWarning>
      {childElement}
    </span>
  );
};
